<template>
  <div class="format-edit">
    <v-row>
      <v-col span="10">
        <span>名称</span><br>
        <v-input style="width:80%"></v-input>
        <div style="height:20px"></div>
        <span>分类</span><br>
        <v-select style="width:80%"></v-select>
        <div style="height:20px"></div>
        <!-- <span>可选背景色</span><br> -->
        <div class="form-group  required"><label class="control-label"
                 for="backdrop_ids">可选背景色</label><br>
          <select class="form-control"
                  id="backdrop_ids"
                  multiple=""
                  name="backdrop_ids"
                  required="">
            <option value="1">蓝</option>
            <option value="2">白</option>
            <option value="3">红</option>
            <option value="12">深蓝</option>
            <option value="4">渐变蓝</option>
            <option value="5">渐变灰</option>
            <option value="15">浅蓝色</option>
            <option value="14">淡蓝渐变</option>
            <option value="13">会计蓝</option>
            <option value="11">绿</option>
            <option value="10">黄</option>
            <option value="9">高考蓝</option>
            <option value="8">喜庆红</option>
            <option value="7">深蓝色</option>
          </select>
        </div>
        <div style="height:20px"></div>
        <span>毫米宽度</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <div style="height:20px"></div>
        <span>毫米高度</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <div style="height:20px"></div>
        <span>像素宽度</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <div style="height:20px"></div>
        <span>像素高度</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <div style="height:20px"></div>
        <span>最大文件大小要求</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <br><span style="color:gray">若无要求请留空；单位：字节</span>
        <div style="height:20px"></div>
        <span>最小文件大小要求</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <br><span style="color:gray">若无要求请留空；单位：字节</span>
        <div style="height:20px"></div>
        <span>尺寸要求描述</span><br>
        <v-input style="width:80%"></v-input>
        <div style="height:20px"></div>
        <span>其它要求</span><br>
        <v-input type="textarea"
                 style="width:80%"></v-input>
        <br><span style="color:gray">若无要求请留空；支持换行</span>
        <div style="height:20px"></div>
        <span>证件照生成参数</span><br>
        <v-input style="width:80%"></v-input>
        <br><span style="color:gray">用逗号分隔，共 10 个</span>
        <div style="height:20px"></div>
        <span>排序权重</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <br><span style="color:gray">值越大越前</span>
        <div style="height:20px"></div>
        <span>分辨率 PPI</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <div style="height:20px"></div>
        <span>摄像头要求</span><br>
        <v-select style="width:80%"></v-select>
        <div style="height:20px"></div>
        <span>人脸数量要求</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <br><span style="color:gray">照片中的人脸数量</span>
        <div style="height:20px"></div>
        <span>图片下增加的额外高度，用来显示文字</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <br><span style="color:gray">单位像素，可留空</span>
        <div style="height:20px"></div>
        <span>文字字号</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <br><span style="color:gray">单位Point，可留空</span>
        <div style="height:20px"></div>
        <span>文字最大长度</span><br>
        <v-input-number style="width:80%"
                        :min="1"
                        :max="10"></v-input-number>
        <br><span style="color:gray">单位字符，可留空</span>
        <div style="height:20px"></div>
        <v-checkbox>允许填写额外的文本信息</v-checkbox><br>
        <v-checkbox>支持冲印</v-checkbox><br>
        <v-checkbox>启用该规格</v-checkbox><br>
        <div style="height:20px"></div>
        <v-button type="primary">提交</v-button>
      </v-col>
      <v-col span="14">
        <v-button type="primary"
                  @click="visible=true">添加槽</v-button>
        <v-button type="primary"
                  ghost
                  @click="backManager"
                  icon="left"
                  style="float:right">返回</v-button>
        <div style="height:20px;"></div>
        <el-table :data="tableData"
                  style="width: 100%">
          <el-table-column prop="x"
                           label="X">
          </el-table-column>
          <el-table-column prop="y"
                           label="Y">
          </el-table-column>
          <el-table-column prop="jiaodu"
                           label="逆时针旋转角度">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text"
                         @click="editRow"
                         size="small">修改</el-button>
              <el-button type="text"
                         @click="handleClick(scope.row)"
                         size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </v-col>
    </v-row>
    <v-modal title="添加槽"
             :visible="visible"
             @ok="visible=false"
             @cancel="visible=false">
      <span>X</span>
      <v-input></v-input>
      <div style="height:20px;"></div>
      <span>Y</span>
      <v-input></v-input>
      <div style="height:20px;"></div>
      <span>逆时针旋转角度</span>
      <v-input-number style="width:100%"
                      :min="1"
                      :max="10"></v-input-number>
    </v-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      tableData: [{
        x: '281',
        y: '133',
        jiaodu: '0'
      }, {
        x: '281',
        y: '133',
        jiaodu: '0'
      }, {
        x: '281',
        y: '133',
        jiaodu: '0'
      }, {
        x: '281',
        y: '133',
        jiaodu: '0'
      }]
    }
  },
  methods: {
    backManager () {
      this.$router.go(-1)// 返回上一层
    },
    editRow () {
      this.visible = true
    }
  }
}
</script>

<style lang="stylus">
.format-edit
  .ant-checkbox+span, .ant-checkbox-wrapper+span
    display inline-block
    vertical-align top
    margin-top 3px
  #backdrop_ids
    height 200px
    width 80%
    padding 6px 12px
    border 1px solid #ccc
    border-radius 4px
    box-sizing border-box
    outline none
  #backdrop_ids:focus
    border 1px solid #96aee4
</style>



// WEBPACK FOOTER //
// src/pages/format/format-edit.vue